import { TemplateAvailability } from '@dealstack/shared/lib/generated';

// Mode wins over count. `dealCount` is mode-independent on the server, so a template in
// ALL_DEALS mode keeps its preserved selection — reading the count first would misreport it
// as reaching only those deals.
export const availabilityLabel = (
	availability: TemplateAvailability,
	dealCount: number
): string => {
	if (availability === TemplateAvailability.ALL_DEALS) {
		return 'All deals';
	}
	if (dealCount === 0) {
		return 'No deals';
	}
	if (dealCount === 1) {
		return '1 deal';
	}
	return `${dealCount} deals`;
};

// Sorting on the label would order "10 deals" before "2 deals". Rank by how far the template
// actually reaches instead: nothing, then N deals, then everything.
export const availabilityRank = (availability: TemplateAvailability, dealCount: number): number => {
	if (availability === TemplateAvailability.ALL_DEALS) {
		return Number.POSITIVE_INFINITY;
	}
	return dealCount;
};
